export enum ActionType {
    TC__TI__RELOAD = 'TC__TI__RELOAD',
    TC__TI__RELOAD_RESULT = 'TC__TI__RELOAD_RESULT',
    TC__TI__SELECT_USER = 'TC__TI__SELECT_USER',
    TC__TI__SELECT_DATE_RANGE = 'TC__TI__SELECT_DATE_RANGE',
    TC__TI__LIST_MEETINGS = 'TC__TI__LIST_MEETINGS',
    TC__TI__RECEIVE_MEETINGS = 'TC__TI__RECEIVE_MEETINGS',
}
